"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var colors_1 = require("../util/colors");
var hooks_1 = require("../util/hooks");
var icons_1 = require("../icons");
var Circle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 24px;\n  width: 24px;\n  border-radius: 100%;\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 100%;\n"], ["\n  height: 24px;\n  width: 24px;\n  border-radius: 100%;\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 100%;\n"])), function (_a) {
    var active = _a.active;
    return (active ? colors_1.colors.primary700 : colors_1.colors.gray100);
}, function (_a) {
    var active = _a.active;
    return active ? colors_1.colors.primary700 : 'transparent';
}, function (_a) {
    var active = _a.active;
    return (active ? colors_1.colors.white : colors_1.colors.gray600);
});
var steps = ['WELCOME', 'PLANS & PRICING', 'CHECKOUT'];
var NavSteps = function (_a) {
    var step = _a.step, nameOverride = _a.nameOverride;
    var isNarrow = (0, hooks_1.useBreakpoint)('lg');
    return (react_1.default.createElement(grid_1.Container, { center: true, wrap: false }, isNarrow
        ? nameOverride || steps[step]
        : steps.map(function (s, idx) { return (react_1.default.createElement(react_1.default.Fragment, { key: s },
            react_1.default.createElement(Circle, { active: step === idx }, step > idx ? react_1.default.createElement(icons_1.Check, { scale: 0.75 }) : idx + 1),
            react_1.default.createElement(typography_1.H5, { pl: 1, color: colors_1.colors.gray600 }, step === idx && nameOverride ? nameOverride : s),
            idx < steps.length - 1 && (react_1.default.createElement(spacing_1.Div, { px: 2 },
                react_1.default.createElement(spacing_1.Div, { bb: true, style: { width: '24px' } }))))); })));
};
exports.default = NavSteps;
var templateObject_1;
//# sourceMappingURL=NavSteps.js.map